var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWomanWorking1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1128.57 1165.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.52;fill:url(#linear-gradient);}.cls-2,.cls-3{fill:#fff;}.cls-3{opacity:0.5;}.cls-4{fill:#ff4a51;}.cls-5{fill:#febc2e;}.cls-6{fill:#26c940;}.cls-7{fill:#c7dbff;opacity:0.24;}.cls-8{fill:none;}.cls-9{fill:#ffb999;}.cls-10{fill:#fc8c60;}.cls-11{fill:#fe6f5d;}.cls-12{fill:#78ad04;}.cls-13{fill:#83ce00;}.cls-14{fill:#ade701;}.cls-15{fill:#02263c;}.cls-16{fill:#e8463a;}.cls-17{fill:#f1dee0;}.cls-18{fill:#f9eded;}.cls-19{fill:#ce2420;}.cls-20{fill:#ceb6b9;}.cls-21{fill:#f6c375;}.cls-22{fill:#f2a641;}.cls-23{fill:#4092c1;}.cls-24{fill:#1b739b;}.cls-25{fill:#1e6882;}.cls-26{fill:#ea754b;}.cls-27{fill:#dd2f22;}.cls-28{fill:#2b2b2b;}.cls-29{fill:#ff9271;}.cls-30{fill:#c9522d;opacity:0.49;}.cls-31{fill:#c6221e;opacity:0.55;}.cls-32{fill:#f9895d;}.cls-33{fill:#021b28;}.cls-34{fill:#ccb0b4;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 775.27,
    y1: 55.39,
    x2: 775.27,
    y2: 486.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7fafc",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#ecf3fd",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#dce9fe",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#d1e1fe",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#caddff",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#c7dbff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 421.96,
    y: 25.69,
    width: 706.61,
    height: 505.27,
    rx: 31.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 502.51,
    y: 143.64,
    width: 545.51,
    height: 34.44,
    rx: 17.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 504.45,
    y: 216.11,
    width: 69.96,
    height: 55.56,
    rx: 5.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 600.59,
    y: 248.79,
    width: 441.4,
    height: 16.49,
    rx: 8.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 600.59,
    y: 223.32,
    width: 378.56,
    height: 16.64,
    rx: 8.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 600.59,
    y: 342.66,
    width: 441.4,
    height: 16.49,
    rx: 8.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 600.59,
    y: 317.19,
    width: 378.56,
    height: 16.64,
    rx: 8.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 600.59,
    y: 433.66,
    width: 441.4,
    height: 16.49,
    rx: 8.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 600.59,
    y: 408.19,
    width: 378.56,
    height: 16.64,
    rx: 8.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 504.45,
    y: 309.69,
    width: 69.96,
    height: 55.56,
    rx: 5.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 504.45,
    y: 403.28,
    width: 69.96,
    height: 55.56,
    rx: 5.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 449.6,
    cy: 56.21,
    r: 5.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 470.43,
    cy: 56.21,
    r: 5.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 491.26,
    cy: 56.21,
    r: 5.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 422.21,
    y: 80.29,
    width: 705.94,
    height: 2.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 433.42,
    y1: 312.1,
    x2: 428.15,
    y2: 304.54
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "429.75 996.42 420.72 1053.74 449.8 1068.42 481.7 1012.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "477.09 1020.99 465.38 1041.26 426.08 1019.69 428.81 1002.17 477.09 1020.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M455.49,1102c0,6.38.4,11.65,4,16.19l.08.09a19.94,19.94,0,0,0,1.52,1.66l27.26,29.51a9.84,9.84,0,0,1,1.33,11.13h0a9.85,9.85,0,0,1-13,4.28L397,1127a14.39,14.39,0,0,1-7-18.6l21.77-51.11a9,9,0,0,1,12-4.67L450.7,1065a9,9,0,0,1,4.84,11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M642.8,471.08c2.14,3.55,7.38,3.15,10.61,5.74,7.4,5.93,16.16,9.1,34.89,8.23-1.24,4.92-5.59,8.39-10,10.89a58.31,58.31,0,0,1-48.38,3.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M638.6,468.73c.38,5.66,7,8.46,9.31,13.63,5.27,11.83,13.94,21.18,37.23,31.85-4.58,5.19-12,6.69-18.95,7A79.68,79.68,0,0,1,605,495.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M531.55,642.87c2.14,3.54,7.38,3.15,10.62,5.74,7.39,5.92,16.16,9.1,34.88,8.23-1.23,4.91-5.58,8.39-10,10.88a58.31,58.31,0,0,1-48.38,3.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M527.36,640.52c.38,5.65,7,8.45,9.3,13.63C541.94,666,550.6,675.32,573.9,686c-4.58,5.2-12,6.7-19,7a79.74,79.74,0,0,1-61.2-25.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M604.28,484.93c-4.06-.8-5.47-5.86-9-8-8.09-4.94-14.06-12.1-19.62-30-4.2,2.84-6,8.11-6.83,13.1a58.31,58.31,0,0,0,12.86,46.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M607.92,488.08c-5.45,1.56-10.33-3.7-16-4.11-12.92-.93-24.66-5.9-42.63-24.17-3.32,6.08-2.19,13.6-.09,20.2a79.7,79.7,0,0,0,44.93,48.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M554.34,534.88c-4.07-.81-5.48-5.87-9-8-8.08-4.93-14.05-12.09-19.62-30-4.19,2.83-6,8.1-6.83,13.1a58.35,58.35,0,0,0,12.86,46.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M558,538c-5.44,1.57-10.33-3.7-16-4.1-12.92-.94-24.66-5.9-42.62-24.17-3.33,6.08-2.2,13.6-.1,20.2a79.69,79.69,0,0,0,44.94,48.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M490.77,620.39c-4.07-.8-5.48-5.86-9-8-8.08-4.94-14.05-12.1-19.62-30-4.19,2.84-6,8.11-6.82,13.1a58.28,58.28,0,0,0,12.86,46.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M494.4,623.54c-5.44,1.57-10.33-3.7-16-4.11-12.92-.93-24.65-5.9-42.62-24.16-3.33,6.07-2.2,13.59-.1,20.19a79.75,79.75,0,0,0,44.94,48.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M551.11,494c13.71,36.74,47.22,57.81,78.42,69.81,18.81-33.05,38.31-72.47,42.37-110.64,1.45-13.53,4.52-35.48-8.88-37.79-6.76-1.15-19.32,6.55-25.11,10.21A546.25,546.25,0,0,0,551.11,494Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M489.8,563.88v0c18.9,38,60.08,57.27,92.85,66.86,9.87-11.88,19.28-24.14,28-36.89,6.72-9.81,13.05-19.82,18.86-30-31.2-12-64.71-33.07-78.42-69.81A554.33,554.33,0,0,0,489.8,563.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M415.55,706.4l95.44.28c24.86-24.34,49.47-49.19,71.66-75.92-32.77-9.59-73.95-28.83-92.85-66.86C457.54,607.56,431.93,655.82,415.55,706.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M451.72,707.87a1,1,0,0,1-.6-.21,1,1,0,0,1-.2-1.4l204.33-269.6a1,1,0,0,1,1.41-.2,1,1,0,0,1,.19,1.41L452.53,707.47A1,1,0,0,1,451.72,707.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M629.57,530.08A125.61,125.61,0,0,1,591,523.53a1,1,0,0,1,.7-1.88c.21.08,21.65,7.85,44.41,6.18a1,1,0,1,1,.15,2Q632.89,530.08,629.57,530.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M585,530.61a1,1,0,0,1-.67-.25c-.13-.11-13-11.64-20.13-27.48a1,1,0,1,1,1.84-.82c6.91,15.45,19.5,26.68,19.62,26.79a1,1,0,0,1-.66,1.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M554.46,570.1a1,1,0,0,1-.69-.28c-.12-.11-12.64-12.06-19.21-28.12a1,1,0,1,1,1.87-.76c6.39,15.66,18.6,27.31,18.72,27.42a1,1,0,0,1,0,1.42A1,1,0,0,1,554.46,570.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M506.27,633.83a1,1,0,0,1-.8-.39c-.11-.14-10.66-13.85-14.69-30.73a1,1,0,1,1,2-.47c3.94,16.46,14.22,29.83,14.33,30a1,1,0,0,1-.79,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M538.76,652.67a126.13,126.13,0,0,1-38.57-6.54,1,1,0,0,1,.69-1.89c.22.08,21.66,7.85,44.42,6.19a1,1,0,1,1,.15,2C543.2,652.6,541,652.67,538.76,652.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M564.29,598.52h-.12a125.35,125.35,0,0,1-25.39-5.73,1,1,0,0,1,.7-1.89,123.19,123.19,0,0,0,24.93,5.62,1,1,0,0,1-.12,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M647.72,488.41h-.12a125.14,125.14,0,0,1-25.38-5.73,1,1,0,1,1,.69-1.89,123.19,123.19,0,0,0,24.93,5.62,1,1,0,0,1-.12,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M593.23,560.49h-.12a125.36,125.36,0,0,1-25.38-5.73,1,1,0,0,1,.7-1.89,122.35,122.35,0,0,0,24.92,5.63,1,1,0,0,1-.12,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M607.14,501.38a1,1,0,0,1-.73-.31,113.59,113.59,0,0,1-9.64-12.15,1,1,0,0,1,.25-1.4,1,1,0,0,1,1.4.25,111.54,111.54,0,0,0,9.45,11.91,1,1,0,0,1,0,1.42A1,1,0,0,1,607.14,501.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M481,668a1,1,0,0,1-.73-.32,110.81,110.81,0,0,1-9.65-12.14,1,1,0,0,1,.25-1.4,1,1,0,0,1,1.4.25,114.17,114.17,0,0,0,9.45,11.91,1,1,0,0,1,0,1.42A1,1,0,0,1,481,668Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M447,659.82c-4.56,4.86-9,10-12,16a47.55,47.55,0,0,0-4.8,18.43,98.33,98.33,0,0,0,.17,13.73c.14,1.92,3.16,1.94,3,0-.52-7.13-.67-14.44.93-21.45a43.22,43.22,0,0,1,7.34-15.77A91,91,0,0,1,449.1,662c1.33-1.42-.8-3.56-2.13-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M665.39,466.79c1.47-6.56,2.49-13.21,3.33-19.88a3,3,0,0,0-3-3,3.1,3.1,0,0,0-3,3c-.72,5.68-1.76,12.25-3.12,18.27a3,3,0,0,0,5.82,1.61Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 666.84,
    cy: 437.36,
    rx: 2.46,
    ry: 3.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M45.5,503.21c-2.14,3.55-7.38,3.15-10.62,5.74-7.39,5.92-16.16,9.1-34.88,8.23,1.24,4.92,5.58,8.39,10,10.89a58.33,58.33,0,0,0,48.39,3.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M49.69,500.86c-.38,5.66-7,8.46-9.3,13.63-5.28,11.83-13.94,21.18-37.24,31.85,4.58,5.19,12,6.69,19,7a79.68,79.68,0,0,0,61.2-25.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M156.75,675c-2.15,3.54-7.39,3.15-10.62,5.74-7.4,5.92-16.16,9.1-34.89,8.23,1.24,4.91,5.59,8.38,10,10.88a58.31,58.31,0,0,0,48.38,3.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M160.94,672.65c-.38,5.65-7,8.45-9.3,13.63-5.28,11.82-13.95,21.17-37.24,31.84,4.58,5.2,12,6.7,19,7a79.74,79.74,0,0,0,61.2-25.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M84,517.06c4.07-.8,5.48-5.87,9-8,8.08-4.94,14-12.1,19.62-30,4.19,2.83,6,8.11,6.83,13.1a58.35,58.35,0,0,1-12.86,46.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M80.38,520.21c5.44,1.56,10.33-3.7,16-4.11,12.92-.93,24.66-5.9,42.62-24.17,3.33,6.08,2.2,13.6.1,20.2A79.69,79.69,0,0,1,94.14,561"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M134,567c4.06-.81,5.48-5.87,9-8,8.09-4.93,14.06-12.09,19.62-30,4.2,2.83,6,8.1,6.83,13.1a58.32,58.32,0,0,1-12.86,46.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M130.33,570.15c5.44,1.57,10.33-3.7,16-4.1,12.91-.94,24.65-5.9,42.62-24.17,3.33,6.07,2.19,13.6.09,20.2a79.73,79.73,0,0,1-44.93,48.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M197.53,652.52c4.06-.8,5.48-5.86,9-8,8.09-4.94,14.06-12.1,19.62-30,4.2,2.84,6,8.11,6.83,13.1a58.31,58.31,0,0,1-12.86,46.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M193.89,655.67c5.45,1.57,10.33-3.7,16-4.11,12.92-.93,24.66-5.9,42.63-24.16,3.32,6.07,2.19,13.59.09,20.19a79.7,79.7,0,0,1-44.93,48.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M137.19,526.13C123.48,562.88,90,584,58.77,596,40,562.9,20.46,523.48,16.39,485.31c-1.44-13.53-4.52-35.48,8.89-37.79,6.75-1.15,19.32,6.55,25.11,10.21A546.64,546.64,0,0,1,137.19,526.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M198.5,596v0c-18.9,38-60.09,57.27-92.85,66.86C95.78,651,86.37,638.74,77.62,626c-6.71-9.81-13-19.82-18.85-30,31.2-12,64.71-33.07,78.42-69.82A555.92,555.92,0,0,1,198.5,596Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M272.75,738.53l-95.44.28c-24.87-24.34-49.47-49.19-71.66-75.92,32.76-9.59,73.95-28.83,92.85-66.86C230.76,639.69,256.37,688,272.75,738.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M236.57,740a1,1,0,0,1-.8-.4L31.44,470a1,1,0,0,1,1.61-1.21l204.32,269.6a1,1,0,0,1-.8,1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M58.72,562.2c-2.2,0-4.44-.07-6.68-.23a1,1,0,0,1,.14-2c22.78,1.67,44.21-6.1,44.42-6.18a1,1,0,1,1,.7,1.88A125.8,125.8,0,0,1,58.72,562.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M103.3,562.74a1,1,0,0,1-.75-.34,1,1,0,0,1,.08-1.42c.13-.11,12.72-11.36,19.63-26.79a1,1,0,1,1,1.83.82c-7.09,15.84-20,27.36-20.12,27.48A1,1,0,0,1,103.3,562.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M133.83,602.23a1,1,0,0,1-.69-1.74c.13-.11,12.34-11.78,18.73-27.43a1,1,0,1,1,1.86.76c-6.56,16.07-19.08,28-19.21,28.13A1,1,0,0,1,133.83,602.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M182,666a1,1,0,0,1-.79-1.62c.1-.14,10.39-13.52,14.32-30a1,1,0,0,1,2,.47c-4,16.88-14.59,30.59-14.69,30.73A1,1,0,0,1,182,666Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M149.53,684.8c-2.2,0-4.43-.07-6.68-.24a1,1,0,1,1,.14-2c22.79,1.67,44.21-6.11,44.42-6.19a1,1,0,0,1,.7,1.89A126.15,126.15,0,0,1,149.53,684.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M124,630.65a1,1,0,0,1-.12-2A122.76,122.76,0,0,0,148.82,623a1,1,0,1,1,.69,1.89,125.14,125.14,0,0,1-25.38,5.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M40.58,520.54a1,1,0,0,1-.12-2,122.76,122.76,0,0,0,24.92-5.62,1,1,0,0,1,.7,1.89,125.36,125.36,0,0,1-25.38,5.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M95.06,592.62a1,1,0,0,1-1-.89,1,1,0,0,1,.87-1.11A122.92,122.92,0,0,0,119.87,585a1,1,0,0,1,.7,1.89,125.35,125.35,0,0,1-25.39,5.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M81.16,533.51a1,1,0,0,1-.73-1.7,111.54,111.54,0,0,0,9.45-11.91,1,1,0,1,1,1.65,1.15,112.84,112.84,0,0,1-9.65,12.15A1,1,0,0,1,81.16,533.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M207.32,700.1a1,1,0,0,1-.73-1.7A112.6,112.6,0,0,0,216,686.49a1,1,0,1,1,1.65,1.15,110.11,110.11,0,0,1-9.64,12.14A1,1,0,0,1,207.32,700.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M239.19,694.09c4.37,4.65,8.54,9.57,11.46,15.27a44.07,44.07,0,0,1,4.47,17.38,98.12,98.12,0,0,1-.19,13.39c-.14,1.93,2.87,1.92,3,0,.55-7.46.63-15.07-1.06-22.4a45.82,45.82,0,0,0-7.8-16.59,99.89,99.89,0,0,0-7.75-9.19c-1.33-1.42-3.46.72-2.14,2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.73,497.31c-.7-3.09-1.29-6.21-1.81-9.33s-1-6.17-1.31-8.94c-.2-1.56-1.25-3.09-3-3-1.47.06-3.23,1.34-3,3,.84,6.67,1.86,13.32,3.33,19.88a3,3,0,0,0,3.71,2.1,3.09,3.09,0,0,0,2.11-3.71Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 21.46,
    cy: 469.49,
    rx: 2.46,
    ry: 3.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M47.54,341.45a78.8,78.8,0,0,0,16.1,31.76,82.18,82.18,0,0,0,28.31,22,76,76,0,0,0,19.29,6.11c1.89.32,2.7-2.57.79-2.9-23-4-43.31-19.06-54.51-39.41a73.38,73.38,0,0,1-7.08-18.3c-.45-1.88-3.34-1.09-2.9.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M55.08,262.09c-14.75,14.62-21.77,35.28-22.38,55.75a127.19,127.19,0,0,0,4,34.13c2.59,10.48,6.39,20.72,12.2,29.87a87.78,87.78,0,0,0,23.17,24.38,3,3,0,0,0,4.11-1.07A3.08,3.08,0,0,0,75.08,401a80.09,80.09,0,0,1-19.33-19.67,89.76,89.76,0,0,1-12.28-27.15c-5.55-20.05-7.12-41.8-.27-61.73a67.61,67.61,0,0,1,16.12-26.16c2.74-2.72-1.5-7-4.24-4.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M47.57,323.65c-2.75,24,6.52,48.71,23.51,65.68a76,76,0,0,0,16,12.25A1.5,1.5,0,0,0,88.6,399C68.29,387.37,54.4,366,50.89,343a73.47,73.47,0,0,1-.32-19.37c.22-1.92-2.79-1.9-3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M131.22,268.7c-19.94-8.55-42.55-7.15-62.46.78A128.52,128.52,0,0,0,41,285c-8.77,6.35-16.75,13.58-23.15,22.36A86.17,86.17,0,0,0,3.69,337.93c-.9,3.76,4.88,5.36,5.78,1.6A81.86,81.86,0,0,1,20.73,313.6a88.35,88.35,0,0,1,20.32-21.28c15.7-12,34.32-21.51,54.27-23.21,11.11-.95,22.57.35,32.87,4.77a3.09,3.09,0,0,0,4.1-1.08c.74-1.26.43-3.46-1.07-4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M71.15,284.59C47.89,291,28.39,308.79,19,330.92a75.65,75.65,0,0,0-5.39,19.39,1.56,1.56,0,0,0,1,1.85,1.52,1.52,0,0,0,1.85-1.05c3.14-23.06,17.46-43.94,37.36-55.85A73,73,0,0,1,72,287.48a1.5,1.5,0,0,0-.8-2.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M159.92,111.49c3.77,12.31-2.7,25.82-12.2,34.51s-21.64,13.78-33.08,19.69-22.89,13.27-29,24.59c-5,9.2-5.93,20-9.4,29.89-7,20-21.54,36.22-32.26,54.47C30,298.36,30.64,319.92,40.2,339.77c4.89,10.16,8.57,15.55,14.16,21.5,13.56,14.4,22.51,18.92,36.82,21.63s29.16,1.15,43.25-2.49a120.72,120.72,0,0,0,35.82-15.31c26-17,42.62-44.75,58.31-71.56l19.37-33.1c3.67-6.28,7.43-12.78,8.43-20,.79-5.65-.17-11.4-1.24-17-5-26.31-12.57-52.06-20.1-77.75-.8-2.72-1.63-5.51-3.34-7.77-2.3-3-5.9-4.75-9.38-6.31a397.59,397.59,0,0,0-58.91-21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "227.87 239.16 308.34 239.16 308.34 270.87 221.28 270.87 227.87 239.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M289.42,214.59l5.37,42.64-55-.33s11.77-16.33,10.07-42.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M550.69,325.09c62.72-8.25,89.72-27.82,100.78-40a3.4,3.4,0,0,0-3.78-5.45,87.08,87.08,0,0,1-16,4.89c-9.41,1.84-19.34,1.73-28.4-1.41l-.35-.13A32.44,32.44,0,0,0,609,271c-21.76-2.08-43,10.88-55.57,28.76-2.87,4.08-5.46,8.5-9.36,11.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M316,377.6l26,5.66a261.77,261.77,0,0,0,83.6,4.51h0a206.41,206.41,0,0,0,138.17-59.54l5.83-5.78L552,297.6l-51.15,16.57a137.76,137.76,0,0,1-124.4-20.35l-35.11-26a272.48,272.48,0,0,0-25.76-16.9h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M578.08,320.34c-2.83.63-5.77,1.22-8.8,1.79l-15.8-22.44a72.59,72.59,0,0,1,5.46-6.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M382.73,542.41l-3.45.91c-61.6,16.23-122.35,22.78-186,19.42h-6c4.22-7.07,6.25-14.82,7.51-23,5.87-37.68,2.18-75.56-15.29-109.68l-5.63-11-35.09,90.27-4.14-.43a41.06,41.06,0,0,1-10.78-2.51c-17.34-6.81-28.76-24.87-25.58-43.77l4.15-28.31a386.09,386.09,0,0,1,15.87-67.19,306.77,306.77,0,0,1,23.26-52.91,339.8,339.8,0,0,1,32.27-47.18A46.5,46.5,0,0,1,193,253l34.9-13.83,6.38,4.8a56.69,56.69,0,0,0,70.51-1.81l3.58-3,48.89,49.55a79.06,79.06,0,0,1,19.44,32.79,64.69,64.69,0,0,1,2.8,18.64c0,12.15-3.57,24.2-10.44,36.24a97.1,97.1,0,0,0-11,27l-.13.58a76.24,76.24,0,0,0,.51,33.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M380.61,421.26c-40.66-14.4-70,.85-70,.85l7.6,15L349,444.7l15.25-3.11L373,434Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M315.39,461l-5.06-39.81S329,427,346.45,426.7s33.71-6.51,33.88-6.34L366.78,522.85c.14-.14-11.64,3.93-23.16,4-11,.11-21.74-3.76-21.74-3.76l-1.39-11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M283.66,480.83a76.48,76.48,0,0,1,10.54-19.91,54.73,54.73,0,0,1,19.34-15.15l2.54,12.54c10.14,5.15,21.06,6.45,33.19,3.31a28.33,28.33,0,0,1,9.54-1.1,12.83,12.83,0,0,1,7.29,2.42,16.89,16.89,0,0,1,6.53,13.39v.23c-.48,14.19-5.83,25-24.45,29.27-27.69,6.29-57.63,6.63-71.56,5.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M149.75,447.44,165.63,456a157.12,157.12,0,0,0,91.56,17.91L284.28,471a1.91,1.91,0,0,1,2.08,1.55l7.91,42.29a2,2,0,0,1-1.89,2.32l-24.86.46a786.15,786.15,0,0,1-128.7-8.22h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M259.58,518.32l-24.88-.6c-23.12-.55-46.51-2.16-69.5-4.76a.5.5,0,0,1,.11-1c23,2.6,46.32,4.2,69.42,4.76l24.85.59,31-.54a.48.48,0,0,1,.52.49.52.52,0,0,1-.5.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M646,1032.28c0,1.7,41.23,40.66,41.23,40.66l26-21.74L683.6,993.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M644.2,1030.84c0,1.69,19.46,20.18,19.46,20.18L696,1017.64l-9.52-18.85"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 153.89,
    y: 720.48,
    width: 923.86,
    height: 34.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 153.89,
    y: 720.48,
    width: 923.86,
    height: 18.33
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-23",
    points: "559.92 925.55 491.59 1030.59 419.31 1000.1 467.87 841.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M376.39,601.41c122.54,34.17,215.12,157,268.77,280.75l53.11,122.45-51.69,43.53-35.89-47C516.31,877.42,378.6,756.32,239.76,736.28l-5.41-1h0A88.27,88.27,0,0,1,182,692.66c-.08-.15-.16-.29-.23-.44h0A132.62,132.62,0,0,1,183,566.06l10.44-18.86,26.29,5A211.52,211.52,0,0,0,377.52,520.1h0l159,65.63c75,30.95,111.33,113.67,87.8,187.91a137.31,137.31,0,0,1-16.1,34.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M554.53,933.82,528,974.64a904.24,904.24,0,0,0-72-94.11l9.75-31.76A875.51,875.51,0,0,1,554.53,933.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M608.1,809.46a1,1,0,0,1-.86-.5c-29.46-51.18-63-94.53-99.63-128.85-41.25-38.63-85.49-64.72-131.49-77.54a1,1,0,1,1,.54-1.93c46.31,12.91,90.83,39.16,132.32,78,36.79,34.45,70.43,78,100,129.31a1,1,0,0,1-.87,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M195.18,596.86a116.48,116.48,0,0,1-25.53-2.7,1,1,0,0,1-.73-1.21,1,1,0,0,1,1.22-.73,117.53,117.53,0,0,0,38.2,1.86c27.36-3.33,46.74-16.56,57.59-39.31a1,1,0,0,1,1.81.86c-13.93,29.18-39.89,38.1-59.22,40.44A109.88,109.88,0,0,1,195.18,596.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M744.84,1060.4c5.77,2.72,10.75,4.52,16.38,3.13l.12,0a19.76,19.76,0,0,0,2.14-.69l38.21-12.41a9.86,9.86,0,0,1,10.67,3.46h0a9.86,9.86,0,0,1-1.54,13.57L743.08,1124a14.39,14.39,0,0,1-19.83-1.42l-37.31-41.16a9,9,0,0,1,.8-12.9l22.45-19.3a9,9,0,0,1,12,.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M240.45,475.12c-19.22,0-35.52-2.73-51.51-8.32a.5.5,0,0,1,.33-.95c27,9.42,54.84,10.67,96.26,4.34a.5.5,0,1,1,.16,1C268.61,473.79,253.82,475.12,240.45,475.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M321.51,150.3c2.54,42-20.26,77.6-50.92,79.45S195.68,199,193.14,157c-1.7-28.19-5.41-70.39,15.72-84.54,10.37-6.94,31.91,5.09,52.53,5.09C292.1,77.56,319,108.27,321.51,150.3Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 196.06,
    cy: 155.86,
    rx: 22.59,
    ry: 23.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M293,243.36c-19.15-2.8-33.28-9.54-43.32-16.65,0-.05,0-.11,0-.16a54.86,54.86,0,0,0,20.86,3.25,41.34,41.34,0,0,0,10.7-2.09,44.19,44.19,0,0,0,9.23-4.36l1.13,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M312.42,114.42c-21.7,9.94-46.07,14-67.79,4.68a77.92,77.92,0,0,1-9.13-4.62l-14.67-8.74s-10.8,19.12-25.49,25.43a14.87,14.87,0,0,0,1.43-1,26.67,26.67,0,0,0,3.8-3.55c3.73-4.25,6.18-9.45,8.37-14.66a76.79,76.79,0,0,0,3.27-9,51.74,51.74,0,0,0,1-22.08l-2.25-7.34C215,86,224.25,96.44,235.39,103.39c11.5,7.18,24.89,10.88,38.35,12.56,6.25.79,12.66,1.14,18.79-.34a28.14,28.14,0,0,0,4.25-1.39,15.78,15.78,0,0,1,8.88-1,27.09,27.09,0,0,0,6.37.36Q312.23,114,312.42,114.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M338.56,72.52c-2-13.07-8.94-24.86-16.56-35.67-5.81-8.25-12.21-16.24-20.3-22.26C283.28.89,258.69-.87,235.76.3a138.47,138.47,0,0,0-24.46,3c-17.11,4-33.1,13.24-44.31,26.76S149.61,61.39,150.94,78.9c.74,9.72,3.69,19.16,4.52,28.87s1.1,30.37-5.91,37.13l20.58-19.11,10.36,5.63a15.12,15.12,0,0,0,16.33-1.15,26.08,26.08,0,0,0,3.8-3.55c3.73-4.24,6.18-9.44,8.36-14.65a77,77,0,0,0,3.28-9,51.86,51.86,0,0,0,1-22.07l-2.63-8.58c3.82,13,13.32,23.9,24.82,31.08s24.9,10.88,38.35,12.57c6.25.78,12.67,1.14,18.79-.34a29,29,0,0,0,4.26-1.39,15.86,15.86,0,0,1,8.88-1,26.73,26.73,0,0,0,20.79-4.93C336.91,100.22,340.6,85.59,338.56,72.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M160.39,453.68a.42.42,0,0,1-.22-.05l-8.4-4.09a.51.51,0,1,1,.44-.91l8.4,4.1a.5.5,0,0,1-.22.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M166.64,88.25c2.38,10,.75,20.37-2.36,30-2.63,8.15-6.06,16.85-12.18,23.05a21.86,21.86,0,0,1-10.71,6.1c-4.87,1.11-10.06.85-15,.51A105.59,105.59,0,0,1,70.51,127c-1.55-1.16-3,1.44-1.52,2.59a108.67,108.67,0,0,0,55.27,21.17,68.39,68.39,0,0,0,15.27,0,24.84,24.84,0,0,0,12.55-5.39c7-5.72,10.9-14.55,13.9-22.85,4.05-11.18,6.35-23.35,3.56-35.1-.45-1.88-3.34-1.08-2.9.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M58.64,149.61a137.56,137.56,0,0,0,24,9.26c15.62,4.59,32.6,7,48.69,3.48a53.7,53.7,0,0,0,26.18-14c2.76-2.71-1.48-6.95-4.24-4.24A46.76,46.76,0,0,1,132.09,156a56.19,56.19,0,0,1-5.9,1.24l-1.49.23c.49-.07,0,0-.1,0l-.9.1q-1.5.17-3,.27a84.31,84.31,0,0,1-12.31-.1c-1-.07-2-.16-3-.27l-1.32-.15-.73-.09-.37,0q-3-.41-5.88-1-5.49-1-10.88-2.56a155.66,155.66,0,0,1-17.31-5.94l-.87-.37c-.08,0-.6-.25-.1,0s-.13-.05-.23-.09l-1.49-.65c-.83-.37-1.66-.74-2.49-1.13s-1.4-.66-2.09-1a3.08,3.08,0,0,0-4.11,1.08,3,3,0,0,0,1.08,4.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M63.42,262.87c-9.7,9.69-14.61,22.82-17.67,35.93-.89,3.84-1.64,7.71-2.33,11.59-.33,1.89,2.56,2.7,2.89.8,2.92-16.43,7-34,19.23-46.2a1.5,1.5,0,0,0-2.12-2.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M290.72,11.62l.42.17.21.08c.21.09-.42-.18,0,0,.23.1.46.19.68.3,1.52.66,3,1.38,4.48,2.13a118.11,118.11,0,0,1,14.64,8.91,111.39,111.39,0,0,1,17.72,15.67A94.2,94.2,0,0,1,344.45,62a89.56,89.56,0,0,1,8.19,31.6c.11,1.54.18,3.08.22,4.62.06,1.93,3.06,1.94,3,0a94.23,94.23,0,0,0-7-33.59,95.84,95.84,0,0,0-15.43-25.11,112.18,112.18,0,0,0-18.28-17.1,118.49,118.49,0,0,0-15.66-10c-1.69-.9-3.39-1.75-5.12-2.54a23.19,23.19,0,0,0-2.76-1.19l-.1,0c-1.81-.69-2.59,2.21-.8,2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M288.33,11c2,1,3.92,2.12,5.81,3.28a114.34,114.34,0,0,1,13.63,9.89,111.93,111.93,0,0,1,16.52,17.12A93.74,93.74,0,0,1,338,65.82a89.88,89.88,0,0,1,5.56,32.35c0,1.51-.06,3-.14,4.53-.11,1.92,2.89,1.92,3,0A92.51,92.51,0,0,0,329,42.59,112,112,0,0,0,312.13,24a122.66,122.66,0,0,0-14.87-11.28A66.47,66.47,0,0,0,290,8.49l-.11-.05c-1.73-.84-3.25,1.75-1.51,2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M185.66,159.52a15.13,15.13,0,0,1,8.91-11.77,1.06,1.06,0,0,0,.71-1.26,1,1,0,0,0-1.26-.71A17.13,17.13,0,0,0,183.69,159a1.06,1.06,0,0,0,.71,1.26,1,1,0,0,0,1.26-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M188.59,152.56a5.68,5.68,0,0,1,2.17,1.33,13.84,13.84,0,0,1,2.2,2.62c1.1,1.67,2.17,3.79,2.07,5.7-.07,1.32,2,1.32,2,0,.13-2.41-1.12-4.91-2.43-6.86s-3.14-4.11-5.51-4.76a1,1,0,0,0-.54,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M174.51,417.05a.41.41,0,0,1-.19,0,.49.49,0,0,1-.28-.65l13.76-33.59a.5.5,0,0,1,.65-.28.51.51,0,0,1,.28.66L175,416.74A.51.51,0,0,1,174.51,417.05Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-27",
    cx: 717.52,
    cy: 1054.74,
    rx: 3.11,
    ry: 4.61,
    transform: "translate(-542.07 1256.57) rotate(-64.88)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-27",
    cx: 730.51,
    cy: 1062.46,
    rx: 3.11,
    ry: 4.61,
    transform: "translate(-541.59 1272.77) rotate(-64.88)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-27",
    cx: 744.62,
    cy: 1069.52,
    rx: 3.11,
    ry: 4.61,
    transform: "translate(-539.86 1289.61) rotate(-64.88)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-27",
    cx: 449.1,
    cy: 1076.8,
    rx: 3.11,
    ry: 4.61,
    transform: "translate(-21.5 9.22) rotate(-1.15)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-27",
    cx: 447.92,
    cy: 1091.87,
    rx: 3.11,
    ry: 4.61,
    transform: "matrix(1, -0.02, 0.02, 1, -21.81, 9.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-27",
    cx: 447.84,
    cy: 1107.64,
    rx: 3.11,
    ry: 4.61,
    transform: "translate(-22.12 9.2) rotate(-1.15)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M717.83,1054.84c3-2.46,7.32-3.3,11.1-3,.8.08,2.12.33,1.69,1.37-.34.85-1,1.58-1.41,2.43a11,11,0,0,0-.88,5.92,1.52,1.52,0,0,0,2.8.76,12.25,12.25,0,0,1,6.79-4.72c2.4-.67,6-1,8.21.56l-.69-.89c-.09-.47,0-.4-.31-.11a4.88,4.88,0,0,0-.54.8,12.28,12.28,0,0,0-.79,1.53,13.29,13.29,0,0,0-.27,10.14c.7,1.78,3.6,1,2.9-.8a10.44,10.44,0,0,1,.65-9.19c.72-1.21,2.18-2.64.71-4-1-.9-2.8-1.2-4.1-1.4a15.77,15.77,0,0,0-15.15,6.51l2.79.76a9.08,9.08,0,0,1,.27-3.81,28.72,28.72,0,0,1,1.79-3.38c1.13-2.49-.7-4.85-3.18-5.36a19,19,0,0,0-7.69.35,16.05,16.05,0,0,0-6.82,3.32c-1.48,1.23.65,3.34,2.13,2.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M450.09,1077.62c3.44,1.89,5.78,5.48,6.94,9.17.22.71.6,2.07-.44,2.24a5.35,5.35,0,0,1-1.56-.28,13.52,13.52,0,0,0-1.41-.16,11.35,11.35,0,0,0-6,1.47,1.51,1.51,0,0,0,.36,2.74,12.5,12.5,0,0,1,7,4.5,12.78,12.78,0,0,1,2,3.68,8.32,8.32,0,0,1,.61,4.11l.69-.9c.39-.24.42-.08-.16-.23-.3-.07-.6-.14-.91-.19a13.87,13.87,0,0,0-1.69-.19,13.35,13.35,0,0,0-9.74,3.62c-1.42,1.32.71,3.44,2.12,2.12a10.37,10.37,0,0,1,8.34-2.68c1.35.18,3.15,1.14,4.09-.4.7-1.12.25-3.14,0-4.34a15.71,15.71,0,0,0-11.53-12l.35,2.74a8.24,8.24,0,0,1,3.68-1.06c1.3,0,2.5.44,3.78.44,2.8,0,4-2.75,3.55-5.18A19,19,0,0,0,457,1080a16,16,0,0,0-5.4-5c-1.69-.92-3.21,1.66-1.51,2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M528.24,601.08A85.07,85.07,0,0,1,559.53,621c2.74,2.73,7-1.51,4.24-4.24a91.9,91.9,0,0,0-33.93-21.41,3,3,0,0,0-3.69,2.09,3.05,3.05,0,0,0,2.09,3.69Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 572.48,
    cy: 630.72,
    rx: 4.9,
    ry: 8.1,
    transform: "translate(-256.15 433.44) rotate(-34.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M264.36,267.4a42.18,42.18,0,0,0,24.48-1.56,3.08,3.08,0,0,0,2.09-3.69,3,3,0,0,0-3.69-2.1A36.36,36.36,0,0,1,266,261.61a3.07,3.07,0,0,0-3.69,2.1,3,3,0,0,0,2.1,3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M303.25,262.48l5-1.91a3.37,3.37,0,0,0,1.79-1.38,3.06,3.06,0,0,0,.3-2.31,3,3,0,0,0-1.38-1.8,3,3,0,0,0-2.31-.3l-5,1.91a2.2,2.2,0,0,0-1,.54,2.23,2.23,0,0,0-.77.84,3,3,0,0,0-.3,2.31,3,3,0,0,0,3.69,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M288.52,25.2A51,51,0,0,1,293.11,28c.78.53,1.54,1.08,2.29,1.65-.25-.19-.09-.07.06.05l.55.44,1.09.9a52.31,52.31,0,0,1,3.89,3.7c.62.65,1.22,1.31,1.8,2,.3.36.61.72.9,1.09.12.14.24.29.35.44.58.72-.33-.45.23.29a3.08,3.08,0,0,0,4.1,1.07c1.23-.79,2.1-2.77,1.08-4.1A56.09,56.09,0,0,0,291.55,20a3,3,0,0,0-3,5.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M311.39,50.61l2,3.21a3.17,3.17,0,0,0,1.79,1.38,2.33,2.33,0,0,0,1.2,0,2.27,2.27,0,0,0,1.12-.35,3.08,3.08,0,0,0,1.38-1.8l.1-.79a3,3,0,0,0-.41-1.52l-2-3.2a3.14,3.14,0,0,0-1.8-1.38,2.2,2.2,0,0,0-1.19-.06,2.25,2.25,0,0,0-1.12.36,3.05,3.05,0,0,0-1.38,1.79l-.11.8a3.05,3.05,0,0,0,.41,1.51Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-26",
    cx: 345.33,
    cy: 427.62,
    rx: 37.13,
    ry: 6.17
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-26",
    points: "308.2 417.09 308.2 427.62 338.05 427.62 382.46 427.62 382.46 417.09 341.3 417.09"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-29",
    cx: 345.33,
    cy: 417.09,
    rx: 37.13,
    ry: 6.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M345.51,421.83c-15.9,0-32.8-1.66-32.8-4.74s16.9-4.74,32.8-4.74,32.8,1.66,32.8,4.74S361.41,421.83,345.51,421.83Zm0-8.73c-19.86,0-32.05,2.32-32.05,4s12.19,4,32.05,4,32.05-2.32,32.05-4S365.37,413.1,345.51,413.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M379.11,430.18l-.66,5c-6.17,2-18.67,3.35-33.09,3.35-14.57,0-27.18-1.39-33.28-3.41l-.63-5c5.83,2.14,18.82,3.63,33.91,3.63S373.21,432.3,379.11,430.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M352.86,383.75a61,61,0,0,1,3.83-9.37,68.22,68.22,0,0,1,5.5-9,3,3,0,0,0-1.08-4.1,3.09,3.09,0,0,0-4.11,1.07,71.64,71.64,0,0,0-9.92,19.84,3,3,0,0,0,2.09,3.69,3.07,3.07,0,0,0,3.69-2.1Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 367.36,
    cy: 353.71,
    rx: 5.65,
    ry: 4.3,
    transform: "translate(-137.07 428.63) rotate(-52.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M370,489.91a24.23,24.23,0,0,1-2.07,3.9,105.5,105.5,0,0,1-33.4,5.52,1.5,1.5,0,0,1,0-3A102.15,102.15,0,0,0,370,489.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M372.28,481.05c-.14,1.16-.33,2.29-.56,3.38A76.27,76.27,0,0,1,350,488.55c-1.93.08-1.92-2.92,0-3A73.25,73.25,0,0,0,372.28,481.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M372.63,476.31v0a52.57,52.57,0,0,1-18.83,3c-1.93-.05-1.94-3.05,0-3a49.71,49.71,0,0,0,18.6-3.08A14.73,14.73,0,0,1,372.63,476.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M370.71,468.47a31.06,31.06,0,0,1-15.8,1.44c-1.9-.32-1.09-3.21.8-2.9A27.21,27.21,0,0,0,369,465.88,16.94,16.94,0,0,1,370.71,468.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M292.71,183.25c2.19-.28,5.16-.78,6.69-2.55,1.85-2.13-.23-4.36-1.4-6.21a40.61,40.61,0,0,1-5.65-14.8c-.23-1.29-2.2-.75-2,.54a42.6,42.6,0,0,0,4.14,12.28c1,1.89,2.33,3.57,3.32,5.43,1.23,2.32-3.65,3.08-5.12,3.26-1.29.16-1.3,2.21,0,2.05Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-33",
    cx: 273.96,
    cy: 154.41,
    rx: 6.12,
    ry: 8.7,
    transform: "translate(-11.57 22.62) rotate(-4.63)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-33",
    cx: 304.45,
    cy: 151.94,
    rx: 6.12,
    ry: 8.7,
    transform: "translate(-11.27 25.08) rotate(-4.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M324.31,139.23a28.18,28.18,0,0,0-28.2-5.41l-1-2.83a31.21,31.21,0,0,1,31.19,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M249.28,144.56,247,142.62a31.18,31.18,0,0,1,30-10.39l-.6,2.94a28.17,28.17,0,0,0-27.12,9.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M306.5,146.3a7.25,7.25,0,0,0,5.7-.51,10.3,10.3,0,0,0,3.09-2.35,2.27,2.27,0,0,1-.34,1.63,14.81,14.81,0,0,1-7.22,6.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M303.2,145.56a7.24,7.24,0,0,0,5.31-2.13,10.28,10.28,0,0,0,2.29-3.14,2.25,2.25,0,0,1,.14,1.66,14.8,14.8,0,0,1-5,8.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M269.3,148.79a7.24,7.24,0,0,1-5.72,0,10.17,10.17,0,0,1-3.3-2,2.25,2.25,0,0,0,.49,1.59,14.83,14.83,0,0,0,7.8,6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M272.51,147.75a7.26,7.26,0,0,1-5.48-1.64,10.37,10.37,0,0,1-2.56-2.92,2.24,2.24,0,0,0,0,1.67,14.87,14.87,0,0,0,5.73,8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M308.32,184.83c.89,8.33-5.57,17.55-14.43,18.5s-16.77-6.74-17.66-15.08c0-.2,0-.41-.05-.62a35.91,35.91,0,0,0,32.06-3.42C308.27,184.41,308.3,184.62,308.32,184.83Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "322.04 417.09 322.04 407.01 333.05 409.01 333.05 418.09 322.04 417.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M448.1,380.57c1.6-.23,3.2-.48,4.79-.75a1.5,1.5,0,0,0,1.05-1.84,1.46,1.46,0,0,0-.69-.9,1.69,1.69,0,0,0-1.15-.15c-1.6.27-3.19.52-4.8.75a1.5,1.5,0,0,0-1,1.84,1.46,1.46,0,0,0,.69.9,1.75,1.75,0,0,0,1.15.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M423.44,383.1q7.79-.53,15.54-1.37a1.54,1.54,0,0,0,1.5-1.5,1.51,1.51,0,0,0-1.5-1.5q-7.75.86-15.54,1.37a1.54,1.54,0,0,0-1.5,1.5,1.5,1.5,0,0,0,1.5,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M374,382.45a110.19,110.19,0,0,0,17.49,1.47c7.88.2,15.77,0,23.64-.34,1.93-.09,1.94-3.09,0-3-7.73.36-15.48.53-23.22.35a107.68,107.68,0,0,1-17.11-1.37c-1.89-.35-2.7,2.54-.8,2.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M254.39,601.63a6.87,6.87,0,1,1,6.87-6.87A6.88,6.88,0,0,1,254.39,601.63Zm0-11.74a4.87,4.87,0,1,0,4.87,4.87A4.87,4.87,0,0,0,254.39,589.89Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomanWorking1);
export default __webpack_public_path__ + "static/media/woman_working_1.030349470accbaec3e5e2815a7573202.svg";
export { ForwardRef as ReactComponent };